import Editor from "@monaco-editor/react";
import { Card } from "antd";
import PropTypes from "prop-types";

const DefectTreeEditor = ({
  height = "50vh",
  tree,
  onUpdate,
  loading = false,
}) => {
  return (
    <Card loading={loading}>
      <Editor
        onChange={onUpdate}
        defaultValue={JSON.stringify(tree, null, 2)}
        defaultLanguage="json"
        height={height}
      />
    </Card>
  );
};

DefectTreeEditor.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tree: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  onUpdate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default DefectTreeEditor;
